import Axios from '../Axios';

const cardPermission = {
	create(data) {
		return Axios.post('/restrictions', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get(
			'/restrictions?limit=' + limit + '&page=' + page + search
		);
	},
	readOne(id) {
		return Axios.get('/restrictions/' + id);
	},
	update(id, data) {
		return Axios.put('/restrictions/' + id, data);
	},
	delete(id) {
		return Axios.delete('/restrictions/' + id);
	},
};

export default cardPermission;
